// Per-browser cart identifier — persists in localStorage so each visitor has an isolated cart.
const KEY = "fp_cart_id";

function generateId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return "cart-" + Math.random().toString(36).slice(2) + Date.now().toString(36);
}

export function getCartId() {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = generateId();
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    // Fallback for private-mode / disabled storage — session-only id (still isolates from other tabs is OK).
    return generateId();
  }
}

export function setCartId(id) {
  try { localStorage.setItem(KEY, id); } catch { /* ignore */ }
}

export function cartHeaders() {
  return { "X-Cart-Id": getCartId() };
}
